/**
 * External dependencies
 */
import React from 'react';
import { Box, Stack } from '@towersystems/towersystems-design-system';

/**
 * Internal dependencies
 */
import CardGrid from 'components/card-grid';
import Skeleton from 'react-loading-skeleton';
import Main from 'components/main';

/**
 * Style dependencies
 */
import './styles.scss';

const renderer = () => {
    return (
        <Box alignItems='center' justifyContent='center' display='flex' style={{ height: 250 }} flexDirection='column'>
            <Box style={{ width: '50%', textAlign: 'center' }}>
                <Skeleton style={{ marginBottom: 20 }} circle={true} width={60} height={60} />
                <Skeleton width='100%' lines={2} />
                <Skeleton width='50%' />
            </Box>
        </Box>
    );
};

const GridSkeleton = ({}) => {
    let gridItems = [
        { key: 1, renderer },
        { key: 2, renderer },
    ];

    return (
        <Main>
            <Stack space='large'>
                <Box justifyContent='spaceBetween' alignItems='center' display='flex'>
                    <Skeleton count={1} height={30} width={180} />
                </Box>
                <CardGrid className='grid-skeleton' columns='2' items={gridItems} />
            </Stack>
        </Main>
    );
};

export default GridSkeleton;
